<script>

import Flickity from 'vue-flickity';


/**
 * Vue Component to use with "inline-template" in twig templates.
 *
 * As long as it is inside a parent vue MODULE (e.g. "VueContainer"), it
 * is mounted automatically and can be nested as far as you want.
 *
 * <demo-component inline-template>
 *    <div class="demoComponent">
 *    </div>
 * </demo-component>
 *
 *
 */
export default {

    name: 'SliderComponent',

    components: {
        Flickity,
    },




    data() {
        return {
            flickityOptions: {
                // initialIndex: 3,
                // prevNextButtons: false,
                // pageDots: false,
                wrapAround: true,
            },
        };
    },

    // methods: {
    //     next() {
    //         this.$refs.flickity.next();
    //     },

    //     previous() {
    //         this.$refs.flickity.previous();
    //     },
    // }

};
</script>
